import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const PreviousButton = (props) => {
  return (
    <IconButton onClick={props.onClick}>
      <ChevronLeftIcon />
    </IconButton>
  );
};

export default PreviousButton;
